/**
 * Preguntas frecuentes de la landing.
 *
 * Fuente única: la usa el bloque visual (components/mvpblocks/faq-2.jsx) y el
 * `faqSchema` de SEO que emite Home.jsx. Antes había dos listas distintas —una
 * en el componente y otra dentro de Home.jsx— y decían cosas diferentes: la que
 * el usuario leía no era la que Google indexaba.
 *
 * Regla al editar: **sólo lo que la app hace hoy.** La versión anterior prometía
 * recordatorios automáticos 2 horas antes (la función existe en el backend pero
 * nadie la llama y no hay ningún cron), sincronización bidireccional con Google
 * Calendar, chat en vivo de soporte y "encriptación de nivel empresarial". Nada
 * de eso se podía sostener. Una FAQ que promete de más no ahorra preguntas: las
 * convierte en reclamos.
 */

export const categoriasFaq = [
  { id: 'all', label: 'Todas' },
  { id: 'general', label: 'General' },
  { id: 'clientes', label: 'Tus clientes' },
  { id: 'features', label: 'Funciones' },
  { id: 'pricing', label: 'Precios' },
  { id: 'technical', label: 'Técnico' },
];

export const faqs = [
  {
    id: 'que-es',
    question: '¿Cómo funciona Aturno?',
    answer:
      'Cargás tus servicios, tu personal y tus horarios, y Aturno te da una página propia para que tus clientes reserven solos. Vos ves todos los turnos en un panel, desde la computadora o el teléfono.',
    category: 'general',
  },
  {
    id: 'rubros',
    question: '¿Sirve para mi tipo de negocio?',
    answer:
      'Está pensado para negocios que trabajan con turnos: peluquerías y barberías, centros de estética, consultorios, kinesiología, entrenadores, canchas, clases particulares y estudios profesionales. Al crear tu cuenta elegís tu rubro y ya te aparecen los servicios típicos cargados para editarlos.',
    category: 'general',
  },
  {
    id: 'precio',
    question: '¿Cuánto cuesta usar Aturno?',
    answer:
      'Podés probarlo 14 días gratis, sin tarjeta de crédito. Después elegís el plan que le sirva a tu negocio, y lo cambiás o lo cancelás cuando quieras.',
    category: 'pricing',
  },
  {
    id: 'cancelar',
    question: '¿Puedo cancelar la suscripción cuando quiera?',
    answer:
      'Sí, sin penalidades. Mantenés el acceso hasta el final del período que ya pagaste.',
    category: 'pricing',
  },
  {
    id: 'clientes-instalar',
    question: '¿Mis clientes tienen que instalar algo?',
    answer:
      'No. Entran desde el link de tu negocio, eligen día y horario y listo. No necesitan crear una cuenta ni bajar ninguna aplicación.',
    category: 'clientes',
  },
  {
    id: 'calendario-cliente',
    question: '¿El turno se le agrega al calendario del cliente?',
    answer:
      'Sí. Al confirmar puede agregarlo a Google Calendar con un click, o descargar el archivo del turno si usa el calendario de iPhone, Android u Outlook. También le llega adjunto en el email de confirmación, y el evento trae un aviso 2 horas antes.',
    category: 'clientes',
  },
  {
    id: 'email',
    question: '¿Se avisa por email?',
    answer:
      'Sí. Al confirmar la reserva le llega un email al cliente con el detalle del turno y el código, y a vos otro avisándote de la reserva nueva.',
    category: 'clientes',
  },
  {
    id: 'whatsapp',
    question: '¿Cómo funciona el bot de WhatsApp?',
    answer:
      'Contesta las consultas de tus clientes y toma turnos a cualquier hora, también de madrugada y los domingos. Cuando quieras, entrás a la conversación y respondés vos.',
    category: 'features',
  },
  {
    id: 'sena',
    question: '¿Puedo cobrar una seña al reservar?',
    answer:
      'Sí. Podés pedir una seña por transferencia o en efectivo para confirmar el turno, y así reducir las ausencias.',
    category: 'features',
  },
  {
    id: 'google-calendar',
    question: '¿Se integra con Google Calendar?',
    answer:
      'Sí. Conectás tu cuenta de Google y los turnos que te reservan aparecen en tu propia agenda, así no tenés que mirar dos lugares.',
    category: 'features',
  },
  {
    id: 'horarios',
    question: '¿Puedo configurar mis horarios como quiera?',
    answer:
      'Sí. Definís horarios distintos para cada día, cortes al mediodía, días que no trabajás y bloqueos puntuales. También podés poner precios distintos según el horario.',
    category: 'features',
  },
  {
    id: 'cancela-cliente',
    question: '¿Qué pasa si un cliente cancela?',
    answer:
      'El turno se libera y queda disponible para otra persona. Además tenés lista de espera: si alguien quería ese horario, puede tomarlo.',
    category: 'features',
  },
  {
    id: 'celular',
    question: '¿Puedo usarlo desde el celular?',
    answer:
      'Sí, tanto el panel como la página de reservas funcionan en celular y tablet. No hay que instalar nada.',
    category: 'technical',
  },
  {
    id: 'tecnico',
    question: '¿Necesito conocimientos técnicos?',
    answer:
      'No. La configuración inicial lleva unos minutos y te va guiando paso a paso: elegís tu rubro, cargás servicios y horarios, y tu página de reservas queda lista.',
    category: 'technical',
  },
];
